import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=0d44588c&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=0d44588c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44588c",
  null
  
)

export default component.exports